// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"43d2dc40","600":"6d38f9de","744":"46a0b090","912":"e1f13100","956":"85199491"}[chunkId] + ".chunk.js";
};